// ESTABILIDAD F7 · A4: qué franja toca, en orden de gravedad. Pura, para
// poder probarla sin montar nada: base caída (rojo, modo lectura) >
// interrupción de un servicio (rojo) > ventana de mantenimiento anunciada
// (AMARILLO: es un aviso de algo planeado, no una avería) > reloj del
// servidor desfasado (amarillo, solo a quien administra) > servicio
// secundario en pausa (ámbar). Sin nada que decir, null.
//
// (El componente AvisoServicios.jsx sigue pintando sus casos como siempre; esta función
// es la que dice cuál toca y la usa para la franja de mantenimiento.)
export function franjaDeServicios(estado) {
  if (!estado) return null;
  if (estado.base === 'solo_lectura') return { tono: 'lectura', mensaje: estado.aviso };
  if (estado.incidencia && estado.incidencia.mensaje) {
    return { tono: 'incidencia', mensaje: estado.incidencia.mensaje };
  }
  if (estado.mantenimiento && estado.mantenimiento.mensaje) {
    return { tono: 'mantenimiento', mensaje: estado.mantenimiento.mensaje, fase: estado.mantenimiento.fase };
  }
  // LISTO-PARA-PILOTO c (P11): la hora del servidor desfasada más de lo que
  // tolera el segundo factor. Amarillo (atención), solo llega a quien administra.
  if (estado.reloj && estado.reloj.mensaje) return { tono: 'reloj', mensaje: estado.reloj.mensaje };
  if (estado.aviso) return { tono: 'pausa', mensaje: estado.aviso };
  return null;
}
